import { Action } from "@ngrx/store";
import {
    IRequestsAndOperationsFilter,
    RequestsAndOperations,
    IInterventionDate,
    RequestsAndOperationsList
} from "@edp-models/requests-and-operations";
import {Service} from "@edp-models/service.model";
import { INewRequestAndOperation } from "@edp-pages/requests-and-operations/services/new-request.service";

export enum ERequestsAndOperationsActions {
    GetRequestsAndOperations        = "[RequestsAndOperations] Get Requests and Operations",
    SetRequestsAndOperations        = "[RequestsAndOperations] Set Requests and Operations",
    GetAvailableTimeSlots           = "[RequestsAndOperations] Get Available Time Slots",
    SetAvailableTimeSlots           = "[RequestsAndOperations] Set Available Time Slots",
    AvailableTimeSlotsAPIError      = "[RequestsAndOperations] Set Available Time Slots Api Error",
    SetFilters                      = "[RequestsAndOperations] Set Filters",
    SelectFilters                   = "[RequestsAndOperations] Select Filters",
    SetLoadedRequestsAndOperations  = "[RequestsAndOperations] Set Loaded RequestsAndOperations",
    SetLocalSupportList             = "[RequestsAndOperations] Set First Load RequestsAndOperations",
    SetAssociatedContract           = "[RequestsAndOperations] Set Associated contract to RequestsAndOperations",
    GetServices                     = "[RequestsAndOperations] Get Services",
    SetServices                     = "[RequestsAndOperations] Set Services",
    SetLoadedServices               = "[RequestsAndOperations] Set Loaded Services",
    SetLoadedSlots                  = "[RequestsAndOperations] Set Loaded Slots",
    GetAvailable                    = "[RequestsAndOperations] Get RequestsAndOperations",
    GetRequestsAndOperationsDetails = "[RequestsAndOperations] Get Requests And Operations Details",
    SetRequestsAndOperationsDetails = "[RequestsAndOperations] Set Requests And Operations Details",
    SetNewRequest                   = "[RequestsAndOperations] Set New Request",
    SetSelectedServiceAndMotive     = "[RequestsAndOperations] Set Selected Service and Motive",
    GetSelectedServiceAndMotive     = "[RequestsAndOperations] Get Selected Service and Motive",
    SetNewRequestStatus             = "[RequestsAndOperations] Set New Request Status",
    GetNewRequestStatus             = "[RequestsAndOperations] Get New Request Status",
    SetMotiveId                     = "[RequestsAndOperations] Set Motive Id",
}

export class GetRequestsAndOperations implements Action {
    public readonly type = ERequestsAndOperationsActions.GetRequestsAndOperations;
    constructor(public payload: RequestsAndOperationsList) {}
}

export class SetRequestsAndOperations implements Action {
    public readonly type = ERequestsAndOperationsActions.SetRequestsAndOperations;
    constructor(public payload: RequestsAndOperations[]) {}
}

export class GetAvailableTimeSlots implements Action {
    public readonly type = ERequestsAndOperationsActions.GetAvailableTimeSlots;
}

export class SetAvailableTimeSlots implements Action {
    public readonly type = ERequestsAndOperationsActions.SetAvailableTimeSlots;
    constructor(public payload: IInterventionDate[]) {}
}

export class AvailableTimeSlotsAPIError implements Action {
    public readonly type = ERequestsAndOperationsActions.AvailableTimeSlotsAPIError;
    constructor(public error: Error) {}
}

export class SelectFilters implements Action {
    public readonly type = ERequestsAndOperationsActions.SelectFilters;
    constructor(public args?: string) {}
}

export class SetFilters implements Action {
    public readonly type = ERequestsAndOperationsActions.SetFilters;
    constructor(public payload: IRequestsAndOperationsFilter[]) {}
}

export class GetServices implements Action {
    public readonly type = ERequestsAndOperationsActions.GetServices;
    constructor(public payload: string) {}
    }

export class SetServices implements Action {
    public readonly type = ERequestsAndOperationsActions.SetServices;
    constructor(public payload: Service[]) {}
}

export class SetLoadedServices implements Action {
    public readonly type = ERequestsAndOperationsActions.SetLoadedServices;
    constructor(public payload: boolean) {}
}

export class SetLoadedSlots implements Action {
    public readonly type = ERequestsAndOperationsActions.SetLoadedSlots;
    constructor(public payload: boolean) {}
}

export class SetLoadedRequestsAndOperations implements Action {
    public readonly type = ERequestsAndOperationsActions.SetLoadedRequestsAndOperations;
    constructor(public payload: boolean) {}
}

export class SetLocalSupportList implements Action {
    public readonly type = ERequestsAndOperationsActions.SetLocalSupportList;
    constructor(public payload: boolean) {}
}

export class SetAssociatedContract implements Action {
    public readonly type = ERequestsAndOperationsActions.SetAssociatedContract;
    constructor(public payload: number) {}
}

export class GetRequestsAndOperationsDetails implements Action {
    public readonly type = ERequestsAndOperationsActions.GetRequestsAndOperationsDetails;
    constructor(public payload: RequestsAndOperations) {}
}

export class SetRequestsAndOperationsDetails implements Action {
    public readonly type = ERequestsAndOperationsActions.SetRequestsAndOperationsDetails;
    constructor(public payload: RequestsAndOperations) {}
}

export class SetNewRequest implements Action {
    public readonly type = ERequestsAndOperationsActions.SetNewRequest;
    constructor(public payload: any) {}
}

export class SetSelectedServiceAndMotive implements Action {
    public readonly type = ERequestsAndOperationsActions.SetSelectedServiceAndMotive;
    constructor(public payload: INewRequestAndOperation) {}
}

export class GetSelectedServiceAndMotive implements Action {
    public readonly type = ERequestsAndOperationsActions.GetSelectedServiceAndMotive;
}

export class SetNewRequestStatus implements Action {
    public readonly type = ERequestsAndOperationsActions.SetNewRequestStatus;
    constructor(public payload: any) {}
}

export class GetNewRequestStatus implements Action {
    public readonly type = ERequestsAndOperationsActions.GetNewRequestStatus;
}

export class SetMotiveId implements Action {
    public readonly type = ERequestsAndOperationsActions.SetMotiveId;
    constructor(public payload: string) {}
}

export type RequestsAndOperationsActions = GetRequestsAndOperations
    | SetRequestsAndOperations
    | GetAvailableTimeSlots
    | SetAvailableTimeSlots
    | AvailableTimeSlotsAPIError
    | SetFilters
    | SelectFilters
    | SetLoadedRequestsAndOperations
    | SetLocalSupportList
    | SetAssociatedContract
    | GetServices
    | SetServices
    | SetLoadedServices
    | SetLoadedSlots
    | GetRequestsAndOperationsDetails
    | SetRequestsAndOperationsDetails
    | SetNewRequest
    | SetSelectedServiceAndMotive
    | GetNewRequestStatus
    | SetNewRequestStatus
    | GetNewRequestStatus
    | SetMotiveId;

